import React from 'react';
import {album} from "../../../models/album";
import {NavLink} from "react-router-dom";
import {scrollTo} from "../../../service/ToolsService";

export type albumListProps = {
  albums: album[],
}

export const AlbumList = ({albums}: albumListProps) => {
  if (albums.length === 0) {
    return <p className="text-center text-muted py-4">Aucun album pour le moment.</p>;
  }

  return (
    <div className="row g-3 px-2 pb-2">
      {albums.map((album: album) => (
        <div key={album.albumId} className="col-12 col-sm-6 col-md-4 col-lg-3">
          <NavLink to={`/photo/${album.slug}`} onClick={scrollTo} className="__album_card__">
            {album.cover
              ? <img src={album.cover} alt={album.label} className="__album_card_cover__"/>
              : <div className="__album_card_cover__ __album_card_cover_empty__"><i className="fa-regular fa-images"/></div>
            }
            <div className="__album_card_caption__">
              <h3 className="__album_card_title__">{album.label}</h3>
              {album.photoCount > 0 && (
                <span className="__album_card_count__">
                  <i className="fa-solid fa-camera me-1"/>{album.photoCount} photo{album.photoCount > 1 ? 's' : ''}
                </span>
              )}
            </div>
          </NavLink>
        </div>
      ))}
    </div>
  );
}
